<div style="min-height: 20vh;" class="update-group-dialog">
    <button class="close" mat-button (click)="onClickClose()">X</button>
    <h3 mat-dialog-title style="background-color: lightgray;">{{header}}</h3>
    <mat-dialog-content>
        <div >
            <!-- <mat-form-field appearance="fill">
                <mat-label>Select group to Update poll.</mat-label>
                <mat-select [(ngModel)]="selectedOption" (selectionChange)="manualUpdate()">
                    <mat-option *ngFor="let item of allGroups" [value]="item" >
                      {{item.name | titlecase}}
                    </mat-option>
                  </mat-select>
            </mat-form-field> -->
            <mat-form-field appearance="fill">
                <mat-label>{{label}}</mat-label>
                <input matInput placeholder="Add Name Here" required [(ngModel)]="name">
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <div style="float: right;">
        <button mat-raised-button style="height: 2.2rem;" (click)="clone()" [disabled]="!name" color="primary">Clone</button>
    </div>
</div>